import React, { useEffect, useState, useCallback } from 'react';
import Skeleton from 'react-loading-skeleton';
import axios from 'axios';
import PouchDB from 'pouchdb-browser';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './ObjectDescription.css';
//Notifications
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  addView,
  downloadFile,
  formatTypeIcon,
  getTaxon,
  updateResourceDownloadsCount
} from '../functions/functions';
import Star from '../ui/Stars';
import Comment from '../comment/Comment';
import Objeto from '../object/Objeto';
import { urls } from '../router/urls';
import ReactTooltip from 'react-tooltip';
import ShareResourceModal from '../ui/ShareResourceModal';
import i18n from 'i18next';
import ResourceViewer from '../ui/ResourceViewer';

const ObjectDescription = ({
  match: {
    params: { object_id }
  }
}) => {
  const db = PouchDB('gestor_contenidos_db');
  const { t } = useTranslation();
  const [data, setData] = useState({});
  const [down, setDown] = useState(false);
  const [stars, setStars] = useState(0);
  const [collection, setColletion] = useState({});
  const [relatedResources, setRelatedResources] = useState([]);
  const mime = require('mime-types');
  const [locationPath, setLocationPath] = useState('');
  const [fileName, setFileName] = useState('');
  const [fileExtension, setFileExtension] = useState('');
  const [isPhysical, setIsPhysical] = useState(false);
  const [isACorrectLink, setIsACorrectLink] = useState(false);
  const [resourceIsDownloadable, setResourceIsDownloadable] = useState(false);
  const [
    isResourceDownloadAvailable,
    setIsResourceDownloadAvailable
  ] = useState(false);
  const [resourceImage, setResourceImage] = useState('');

  const checkIfDownloaded = useCallback(
    id => {
      db.get(id)
        .then(() => {
          setDown(true);
        })
        .catch(err => {
          if (err.error) {
            setDown(false);
          }
        });
    },
    [db, setDown]
  );

  const getFileName = useCallback(object => {
    let file_extension = object.technical[0].format.extension;
    let file_name = object.technical[0].location;
    file_name = file_name.split('/').pop();
    let file = object.slug;
    let fileNameSplit = file_name.split('.');
    if (fileNameSplit.length === 1) {
      file = `${file}.${file_extension}`;
    } else {
      file_extension = fileNameSplit.pop();
      file = `${file}.${file_extension}`;
    }
    setFileName(file);
    setFileExtension(file_extension);
  }, [setFileName, setFileExtension]);

  const getIsResourceDownloadAvailable = useCallback(location => {
    axios
      .get(location)
      .then(response => {
        setIsResourceDownloadAvailable(true);
      })
      .catch(response => {
        setIsResourceDownloadAvailable(false);
      });
  }, [setIsResourceDownloadAvailable]);

  const getObject = useCallback(
    () => {
      axios
        .get(urls.url_api + `/api/resource-objects/${object_id}/`)
        .then(response => {
          const object = response.data;
          const location = object.technical[0].is_physical
            ? urls.url_api + object.technical[0].get_location_path
            : object.technical[0].get_location_path;
          const physical = object.technical[0].is_physical;
          setLocationPath(location);
          setIsPhysical(physical);
          setIsACorrectLink(object.technical[0].is_a_correct_link);
          setResourceIsDownloadable(object.rights.is_downloadable);
          setColletion(object['structured_group_data']);
          setData(object);
          if (physical) {
            getFileName(object);
            getIsResourceDownloadAvailable(location);
          }
          setResourceImage(`url(${urls.url_api + object['image']})`);
        });
    },
    [
      object_id,
      getFileName,
      getIsResourceDownloadAvailable,
      setColletion,
      setData,
      setIsACorrectLink,
      setIsPhysical,
      setLocationPath,
      setResourceImage,
      setResourceIsDownloadable
    ]
  );

  const get_qualification = useCallback(
    () => {
      axios
        .get(urls.url_api + `/api/resource-objects/${object_id}/average_ranking/`)
        .then(response => {
          let q = response.data.average_ranking;
          setStars(q);
        })
        .catch(err => {
          setStars(0);
        });
    },
    [object_id, setStars]
  );

  const get_related_resources = useCallback(
    () => {
      axios
        .get(
          urls.url_api +
            `/api/resource-objects/${object_id}/associated_resources/`
        )
        .then(response => {
          let q = response.data;
          setRelatedResources(q);
        })
        .catch(err => {
          setRelatedResources([]);
        });
    },
    [object_id, setRelatedResources]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    checkIfDownloaded(object_id);
    get_qualification();
    get_related_resources();
    i18n.changeLanguage(localStorage.getItem('lang'));
    getObject();
    addView(object_id);
  }, [checkIfDownloaded, getObject, get_qualification, get_related_resources, object_id, db, setDown, setStars, setRelatedResources, setLocationPath, setIsPhysical, setIsACorrectLink, setResourceIsDownloadable, setColletion, setData, setResourceImage]);

  const handleObjectDownloadClick = () => {
    // get metadata
    axios
      .get(urls.url_api + `/api/resource-objects/${object_id}/`)
      .then(response => {
        //save metadata
        let object = response.data;

        let date = new Date();
        const json_date = date.toISOString();

        db.put({
          _id: object.id,
          object: object,
          date_downloaded: json_date
        })
          .then(response => {
            //succefully saved metadata
            let object_db = response;
            if (isPhysical && resourceIsDownloadable) {
              let toastId = null;
              let progress = 0;
              let delay_time = 0;
              const op_sec = 7000000;
              let percentage_download = 65;
              axios
                .get(locationPath, {
                  responseType: 'blob',
                  timeout: 300000,
                  onDownloadProgress: e => {
                    delay_time = Math.ceil(e.total / op_sec);
                    progress =
                      Math.round((e.loaded * percentage_download) / e.total) /
                      100;
                    if (toastId === null) {
                      toastId = toast.info(t('toast_descarg-iniciada'), {
                        progress: progress
                      });
                    } else {
                      toast.update(toastId, {
                        render:
                          i18n.t('toast_descarg-iniciada') +
                          ` (${Math.round(progress * 100)}%)`,
                        progress: progress
                      });
                    }
                  }
                })
                .then(response => {
                  let progress_saving = percentage_download / 100;
                  let progress_step = (1 - progress_saving) / delay_time;
                  const upProgressSaving = () => {
                    progress_saving += progress_step;
                    toast.update(toastId, {
                      render:
                        i18n.t('toast_descarg-iniciada') +
                        ` (${Math.round(progress * 100)}%)`,
                      progress: progress_saving
                    });
                  };
                  let interval = setInterval(upProgressSaving, 1000);

                  let attachment = new Blob([response.data], {
                    type: mime.lookup(fileExtension)
                  });
                  db.putAttachment(
                    object.id,
                    'resource',
                    object_db.rev,
                    attachment,
                    mime.lookup(fileExtension)
                  ).then(function(result) {
                    //se lleva al 100%
                    toast.update(toastId, {
                      progress: 1
                    });

                    //se actualiza para llevarla a success
                    toast.update(toastId, {
                      type: 'success',
                      render: t('toast_descarga_finalizada'),
                      autoClose: 3000,
                      progress: null
                    });
                    updateResourceDownloadsCount(object_id);
                    checkIfDownloaded(object_id);
                    clearInterval(interval);
                    return true;
                  });
                });
            } else {
              toast.dismiss();
              toast.success(t('toast_guardado'));
              checkIfDownloaded(object_id);
            }
          })
          .catch(function(err) {
            console.log(err);
            if (err.name === 'conflict') {
              toast.dismiss();
              toast.warn(t('toast_descargado_prev'));
              checkIfDownloaded(object_id);
              return false;
            }
          });
      });
  };

  return (
    <div>
      <ReactTooltip />
      <div
        style={{ backgroundColor: '#FAC600', width: '100%', height: '12px' }}
      >
        {' '}
      </div>

      {/* Miga de pan */}
      <ol className="breadcrumb m-0">
        <li className="breadcrumb-item">
          <Link to="/" title={t('dashboard')}>
            <i className="fal fa-home"> </i>
            <span> {t('catalogo')}</span>
          </Link>
        </li>
        <li className="breadcrumb-item">
          <Link
            to={`/${urls.agrupaciones}/${collection['id']}`}
            title={t('agregacion')}
          >
            <i className="icon icon-aggregation"> </i>
            <span> {t('agregacion')}</span>
          </Link>
        </li>
        <li className="breadcrumb-item active">
          <span> {data['id'] ? data['general'].title.value : ''}</span>
        </li>
      </ol>

      {/* visualizacion de recurso */}
      <div className="row options">
        <ResourceViewer
          objectId={object_id}
          locationPath={locationPath}
          isPhysical={isPhysical}
          isACorrectLink={isACorrectLink}
          isResourceDownloadAvailable={isResourceDownloadAvailable}
          fileName={fileName}
          fileExtension={fileExtension}
          resourceImage={resourceImage}
        />
      </div>

      <ShareResourceModal
        resource_id={data['id']}
        url={data['id'] ? urls.url_api + data['url'] : ''}
        quote={data['id'] ? data['general'].title.value : ''}
      />

      {data['general'] ? (
        <div className="row">
          <span className="resources-title object-title-pwa">
            {data['general'].title.value}
          </span>
        </div>
      ) : (
        <div
          className="d-flex row mt-6"
          style={{ padding: '0px 30px 15px 30px' }}
        >
          {' '}
          <Skeleton width={350} height={50} />
        </div>
      )}

      {data['id'] ? (
        <div className="row" style={{ padding: '15px 30px 5px 30px' }}>
          {resourceIsDownloadable && isPhysical ? (
            <div className={'col-sm-3 col-auto '}>
              {/* Descarga de datos de archivo */}
              <button
                onClick={() => {
                  updateResourceDownloadsCount(object_id);
                  downloadFile(locationPath, fileName, fileExtension);
                }}
                rel="noopener noreferrer"
                className="fw-400 btn btn-pills btn-white waves-effect waves-themed"
              >
                <i
                  className="fas fa-cloud-download mr-2"
                  style={{ fontSize: '20px' }}
                />
                <span className="download-font">{t('descargar_recurso')}</span>
              </button>
            </div>
          ) : (
            ''
          )}

          {formatTypeIcon(data['technical'][0].format.value) ? (
            <div className={'col-sm-3 col-auto '}>
              <span className="fw-400 btn btn-pills">
                <i
                  style={{ fontSize: '20px' }}
                  className={
                    formatTypeIcon(data['technical'][0].format.value).icon +
                    ' format-icon'
                  }
                />
                <span className="mx-2">
                  {formatTypeIcon(data['technical'][0].format.value)
                    ? t(formatTypeIcon(data['technical'][0].format.value).label)
                    : ''}
                </span>
              </span>
              <div />
            </div>
          ) : (
            ''
          )}
        </div>
      ) : (
        <div
          className="mt-2"
          style={{
            padding: '0px 30px 15px 30px',
            marginRight: '-.75rem',
            marginLeft: '-.75rem'
          }}
        >
          <Skeleton width={50} count={1} />{' '}
        </div>
      )}

      {data['educational'] ? (
        <div className="row tags">
          {data['classification'][0].taxon_path.map((tax, index) => (
            <span className={'tags-pwa'} key={index}>
              {' '}
              {tax.level_one[0].value}{' '}
              {index < data['classification'][0].taxon_path.length - 1
                ? ', '
                : ''}
            </span>
          ))}
        </div>
      ) : (
        <div
          style={{
            padding: '0px 30px 15px 30px',
            marginRight: '-.75rem',
            marginLeft: '-.75rem'
          }}
        >
          <Skeleton count={2} />{' '}
        </div>
      )}

      <div className={'row options'}>
        <div className="col-sm-3 col-12">
          <div className="stars-icon-pwa mb-3 d-inline">
            <Star rating={stars} />
            <span className="stars-pwa fw-900 text-blue">
              {' ' + stars + '.0'}
            </span>
          </div>
        </div>

        <div className="col-sm-3 col-auto link-calificacion">
          <a
            className="options-pwa"
            href={urls.url_api + (data['url'] || '')}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>{t('califica_recurso')} </span>
            <i className={'fal fa-angle-right'}> </i>
          </a>
        </div>

        <div className={'col-sm-3 col-auto options-pwa link-calificacion'}>
          <button
            className="options-pwa"
            data-toggle="modal"
            data-target=".modal-valoration"
          >
            <span>
              {t('ver_comentarios')} (
              {data['id'] ? data['annotation'].length : '0'})
            </span>
          </button>
          <i className={'fal fa-angle-right ml-1'}> </i>
        </div>
        <div className={'col-sm-3 col-auto options-pwa link-calificacion'}>
          <Link
            to={`/${urls.agrupaciones}/${collection['id']}`}
            title={t('agregacion')}
            className="options-pwa fw-700"
          >
            <span>
              <i className={'icon icon-aggregation ms-1'}> </i>
              {t('ir_a_coleccion')}
            </span>
          </Link>{' '}
          <i className={'fal fa-angle-right fw-700'}> </i>
        </div>
      </div>

      {/* modal comentarios*/}

      <div
        className="modal fade modal-backdrop-transparent modal-valoration"
        aria-modal="true"
        style={{ paddingRight: '15px' }}
      >
        <div className="modal-dialog modal-dialog-right modal-md">
          <div className="modal-content">
            <div className="dropdown-header d-flex justify-content-between align-items-center w-100">
              <h4 className="m-0 text-secondary font-weight-bold py-3 roboto-pwa">
                {t('comentario')} (
                {data['id'] ? data['annotation'].length : '0'})
              </h4>
              <button
                type="button"
                className="close text-secondary position-absolute pos-top pos-right p-2 m-1 mr-2 py-3"
                data-dismiss="modal"
              >
                <span>
                  <i className="fal fa-times"> </i>
                </span>
              </button>
            </div>
            <div className="modal-body p-0">
              <div className="settings-panel">
                {data[
                  'id'
                ] /*cuando se carga el recurso verificar si tiene comentarios*/ ? (
                  data['annotation'].length > 0 ? (
                    data['annotation'].map((element, index) => {
                      return (
                        <Comment
                          key={index}
                          stars={element.get_rating}
                          time={element.human_date}
                          description={element.description.value}
                          username={element.user_name}
                        />
                      );
                    })
                  ) : (
                    <h4
                      id="reviewMessage"
                      className="text-center text-secondary fw-500 py-4"
                    >
                      {t('no_comentarios')}
                    </h4>
                  )
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/** iconos opciones **/}
      <div
        className={'row options demo icon-pwa'}
        style={{ marginBottom: '0 0 6px 5px !important' }}
      >
        {/* boton de descarga */}

        {resourceIsDownloadable ? (
          down ? (
            <button
              title={t('recurso_descargado')}
              className="btn btn-success btn-lg btn-icon rounded-circle waves-effect waves-themed"
              type="button"
            >
              <span className="far fa-check"> </span>{' '}
            </button>
          ) : (
            <button
              onClick={() => {
                handleObjectDownloadClick();
              }}
              className="btn btn-default btn-lg btn-icon rounded-circle waves-effect waves-themed"
              type="button"
              title={t('guardar_recurso')}
            >
              <span className="far fa-cloud-download"> </span>{' '}
            </button>
          )
        ) : (
          ''
        )}

        {/* boton favoritos */}

        <div
          className="d-inline show"
          title=""
          data-tip={t('agregar_favoritos')}
        >
          <button
            data-toggle="dropdown"
            className="btn btn-outline-default btn-lg btn-icon rounded-circle waves-effect waves-themed btn-favorites"
          >
            <i className="fas fa-heart"> </i>
          </button>

          <div
            className="dropdown-menu dropdown-md p-4"
            x-placement="bottom-start"
            style={{
              position: 'absolute',
              willChange: 'top, left',
              top: '442px',
              left: ' 24px'
            }}
          >
            <p className="dropdown-option ff-ws">
              <a
                className="link-favorite"
                target="_blank"
                rel="noopener noreferrer"
                href={urls.url_api + urls.agregar_favoritos + object_id + '/'}
              >
                {t('ingresar_colombia_aprende')}{' '}
                <span className="fw-500">{t('colombia_aprende')}</span>.
                <button className="btn btn-outline-info btn-pills btn-block waves-effect waves-themed mt-2">
                  {t('iniciar_sesion_registro')}
                </button>
              </a>
            </p>
          </div>
        </div>

        {/* boton opciones */}

        <div className="d-inline show" data-toggle="tooltip">
          <button
            data-toggle="dropdown"
            className="btn btn-outline-default btn-lg btn-icon rounded-circle waves-effect waves-themed link-share"
            data-tip={t('opciones')}
          >
            <i className="fas fa-ellipsis-h"> </i>
          </button>

          <div
            className="dropdown-menu dropdown-md p-4"
            x-placement="bottom-start"
            style={{
              position: 'absolute',
              willChange: 'top, left',
              top: '442px',
              left: ' 24px'
            }}
          >
            <p className="dropdown-option ff-ws">
              <a
                className="link-favorite"
                target="_blank"
                rel="noopener noreferrer"
                href={urls.url_api + urls.login}
              >
                {t('ingresar_colombia_aprende')}{' '}
                <span className="fw-500">{t('colombia_aprende')}</span>.
                <button className="btn btn-outline-info btn-pills btn-block waves-effect waves-themed mt-2">
                  {t('iniciar_sesion_registro')}
                </button>
              </a>
            </p>
          </div>
        </div>

        {/* boton de compartir */}

        <button
          className="btn btn-outline-default btn-lg btn-icon rounded-circle waves-effect waves-themed"
          data-toggle="modal"
          data-target="#modal-shortcut"
          data-tip={t('compartir')}
        >
          <i className="far fa-share-alt"> </i>
        </button>
      </div>

      {/* descripcion */}
      <div className="row options">
        <ul className="nav nav-tabs nav-tabs-clean nav-pwa" role="tablist">
          <li className="nav-item">
            <a
              className="nav-link active"
              data-toggle="tab"
              href="#tab-home"
              role="tab"
              aria-selected="false"
            >
              {t('descripcion')}
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              data-toggle="tab"
              href="#tab-profile"
              role="tab"
              aria-selected="true"
            >
              {t('sugerencia_uso_pedagogico')}
            </a>
          </li>
        </ul>

        <div className="tab-content p-3">
          <div
            className="tab-pane fade active show ff-ws"
            style={{ color: '#606060' }}
            id="tab-home"
            role="tabpanel"
            aria-labelledby="tab-home"
          >
            {data['id'] ? (
              data['general'].description[0].value
            ) : (
              <Skeleton count={6} height={30} width={300} />
            )}
          </div>
          <div
            className="tab-pane fade ff-ws"
            id="tab-profile"
            style={{ color: '#606060' }}
            role="tabpanel"
            aria-labelledby="tab-profile"
          >
            {data['id'] ? data['educational'].description[0].value : ''}
          </div>
        </div>
      </div>

      {/* grafico */}

      <div className="row grafica-pwa">
        <img
          src={process.env.PUBLIC_URL + '/img/grafica-a.png'}
          alt="logo"
          aria-roledescription="logo"
        />
      </div>

      {/* areas del conocimientp */}

      <div className="row options">
        <h1 className="titles-pwa">
          <div className="mb-3">{t('landing_area_conocimiento')}</div>
          {data['id']
            ? getTaxon(data['classification'][0].taxon_path).map(
                (elemento, index) => {
                  return (
                    <span
                      key={index}
                      className="keyword badge badge-light badge-pill ff-rb"
                    >
                      {elemento}
                    </span>
                  );
                }
              )
            : ''}
        </h1>
      </div>

      {/* grafico */}

      <div className="row grafica-pwa">
        <img
          src={process.env.PUBLIC_URL + '/img/grafica-b.png'}
          alt="logo"
          aria-roledescription="logo"
        />
      </div>

      {/* Palabras Clave */}

      <div className="row options">
        <h1 className="titles-pwa">
          <div className="mb-3">{t('palabra_clave')}</div>
          {data['id']
            ? data['general'].keyword[0].value.map((elemento, index) => {
                return (
                  <span
                    className="keyword badge badge-light badge-pill ff-rb"
                    key={index}
                  >
                    {elemento}
                  </span>
                );
              })
            : ''}
        </h1>
      </div>

      {/* grafico */}

      <div className="row grafica-pwa">
        <img
          src={process.env.PUBLIC_URL + '/img/grafica-c.png'}
          alt="logo"
          aria-roledescription="logo"
        />
      </div>

      {/* Usuario final */}

      <div className="row options">
        <h1 className="titles-pwa">
          <div className="mb-3">{t('publico_objetivo')}</div>
          <span className="keyword badge badge-light badge-pill ff-rb">
            {data['educational'] &&
              data['educational'].intented_end_user_role[0].value}
          </span>
        </h1>
      </div>

      {/* informacion sobre el recurso */}

      <div className="row options-info panel-info-pwa">
        {Array.isArray(data['authors']) && data['authors'].length ? (
          <h5 className="info-pwa col-12 col-md-6">
            {t('autores')}:
            <ul className="pl-4 my-1">
              {data['authors'].map((elemento, index) => {
                return (
                  <li key={index}>
                    <span className={'text-wrap fw-300 mt-1'}>{elemento}</span>
                  </li>
                );
              })}
            </ul>
          </h5>
        ) : (
          ''
        )}
        <h5 className="info-pwa col-12 col-md-6">
          {t('tipo_contenido')}:
          <span>
            <small className="mb-0">
              {data['id']
                ? data['educational'].learning_resource_type.value
                : ''}
            </small>
          </span>
        </h5>

        <h5 className="info-pwa col-12 col-md-6">
          {t('licenciante')}:
          <small className="mb-0 text-info-pwa">
            {data['rights']
              ? data['rights'].copyright_and_other_restrictions.rights_holder
              : ''}
          </small>
        </h5>

        <h5 className="info-pwa col-12 col-md-6">
          {t('tipo_licencia')}:
          <span>
            <small className="mb-0">
              {data['rights']
                ? data['rights'].copyright_and_other_restrictions.license
                : ''}
            </small>
          </span>
        </h5>
      </div>

      {/* recursos relacionados */}

      {relatedResources.length ? (
        <>
          <div className="row options">
            <h1 className="related-resources-title-pwa">
              <div className="mb-3">{t('recursos_relacionados')}</div>
            </h1>
          </div>

          <div className={'row content-pwa'}>
            {relatedResources.map((objeto, index) => (
              <div className="col-12 col-md-6 objeto-pwa" key={index}>
                <Objeto
                  key={index}
                  is_group={objeto.group_type}
                  img={urls.url_api + objeto.image}
                  titulo={objeto.general.title.value}
                  descripcion={objeto.general.description[0].value}
                  id={objeto.id}
                  is_related={true}
                />
              </div>
            ))}
          </div>
        </>
      ) : (
        ''
      )}
    </div>
  );
};

export default ObjectDescription;
